function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9983"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "warning (1)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46101",
    d: "m23.713 38.8-9.747-17.3a2.269 2.269 0 0 0-3.929 0L.289 38.8a2.283 2.283 0 0 0 1.965 3.4h19.419a2.307 2.307 0 0 0 2.04-3.4z",
    transform: "translate(0 -19.359)",
    style: {
      fill: "#e24c4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46102",
    d: "m52.16 63.025 9.747 17.3H42.413l9.747-17.3z",
    transform: "translate(-40.159 -59.758)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9981",
    transform: "translate(10.408 9.387)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46103",
    d: "m195.911 180.039.6 4a.983.983 0 0 0 .982.831 1.046 1.046 0 0 0 .982-.831l.6-4a1.572 1.572 0 0 0-1.587-1.813 1.612 1.612 0 0 0-1.577 1.813z",
    transform: "translate(-195.905 -178.226)",
    style: {
      fill: "#3f4448"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 850",
    cx: 0.907,
    cy: 0.907,
    r: 0.907,
    transform: "translate(.686 7.48)",
    style: {
      fill: "#3f4448"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.c76e8012a7006bbd66add649a5e2194b.svg";
export { ForwardRef as ReactComponent };